import { SchoolUserRoleIdEnum } from "@/enums/aem";
import { UserRoleIdsEnum } from "@/enums/global";

export const AllUserRoleIds: ReadonlyArray<number> = Object.freeze([
  UserRoleIdsEnum.ACADEMIC_EXCELLENCE_MANAGER,
  UserRoleIdsEnum.ADMIN,
  UserRoleIdsEnum.AFFILIATION_HEAD,
  UserRoleIdsEnum.B2C_INDIVIDUAL_TEACHER,
  UserRoleIdsEnum.CENTER_MANAGER,
  UserRoleIdsEnum.CONTENT_HEAD,
  UserRoleIdsEnum.CONTENT_MANAGER,
  UserRoleIdsEnum.DEACTIVE_DEMO_STUDENT,
  UserRoleIdsEnum.DEMO_STUDENT,
  UserRoleIdsEnum.FACULTY,
  UserRoleIdsEnum.MODERATOR,
  UserRoleIdsEnum.PARENT,
  UserRoleIdsEnum.STUDENT,
  UserRoleIdsEnum.SCHOOL_PARTNER_RM,
  UserRoleIdsEnum.SCHOOL_TEACHER,
  UserRoleIdsEnum.TUTOR,
  UserRoleIdsEnum.TUTORING_ADMIN,
  UserRoleIdsEnum.TUTORING_OPS,
  UserRoleIdsEnum.TUTORING_SALES,
  UserRoleIdsEnum.TUTORING_STUDENT,
]);

export const AllStudentRoleIds: ReadonlyArray<number> = Object.freeze([
  UserRoleIdsEnum.DEMO_STUDENT,
  UserRoleIdsEnum.STUDENT,
  UserRoleIdsEnum.TUTORING_STUDENT,
]);

export const AllTeacherRoleIds: ReadonlyArray<number> = Object.freeze([
  UserRoleIdsEnum.FACULTY,
  UserRoleIdsEnum.SCHOOL_TEACHER,
  UserRoleIdsEnum.TUTOR,
]);

export const AllAdminRoleIds: ReadonlyArray<number> = Object.freeze([UserRoleIdsEnum.ADMIN]);

export const InternalMultiAffiliationRoleIds: ReadonlyArray<number> = Object.freeze([
  UserRoleIdsEnum.ACADEMIC_EXCELLENCE_MANAGER,
  UserRoleIdsEnum.ADMIN,
]);

export const AllAemRoleIds: ReadonlyArray<number> = Object.freeze([
  UserRoleIdsEnum.ACADEMIC_EXCELLENCE_MANAGER,
  UserRoleIdsEnum.ADMIN,
  UserRoleIdsEnum.SCHOOL_PARTNER_RM,
]);

export const AllAffiliationRoleIds: ReadonlyArray<number> = Object.freeze([
  UserRoleIdsEnum.AFFILIATION_HEAD,
  UserRoleIdsEnum.FACULTY,
  UserRoleIdsEnum.SCHOOL_TEACHER,
  UserRoleIdsEnum.TUTOR,
]);

export const AllManagerRoleIds: ReadonlyArray<number> = Object.freeze([
  UserRoleIdsEnum.ACADEMIC_EXCELLENCE_MANAGER,
  UserRoleIdsEnum.ADMIN,
  UserRoleIdsEnum.AFFILIATION_HEAD,
  UserRoleIdsEnum.CENTER_MANAGER,
  UserRoleIdsEnum.TUTORING_ADMIN,
]);

export const AllTutoringAdminRoleIds: ReadonlyArray<number> = Object.freeze([
  UserRoleIdsEnum.ADMIN,
  UserRoleIdsEnum.TUTORING_ADMIN,
]);

export const AllTutoringOpsRoleIds: ReadonlyArray<number> = Object.freeze([
  UserRoleIdsEnum.TUTORING_ADMIN,
  UserRoleIdsEnum.TUTORING_OPS,
  UserRoleIdsEnum.TUTORING_SALES,
]);

export const AllContentRoleIds: ReadonlyArray<number> = Object.freeze([
  UserRoleIdsEnum.ADMIN,
  UserRoleIdsEnum.CONTENT_HEAD,
  UserRoleIdsEnum.CONTENT_MANAGER,
  UserRoleIdsEnum.FACULTY,
]);

export const ContentApproverRoleIds: ReadonlyArray<number> = Object.freeze([
  UserRoleIdsEnum.ADMIN,
  UserRoleIdsEnum.CONTENT_HEAD,
  UserRoleIdsEnum.FACULTY,
]);

export const AddEditUserRoleIds: ReadonlyArray<number> = Object.freeze([
  UserRoleIdsEnum.STUDENT,
  UserRoleIdsEnum.DEMO_STUDENT,
  UserRoleIdsEnum.SCHOOL_TEACHER,
  UserRoleIdsEnum.AFFILIATION_HEAD,
]);

export const MandatorySchoolUserRoleIds: ReadonlyArray<number> = Object.freeze([
  SchoolUserRoleIdEnum.AEM,
  SchoolUserRoleIdEnum.CSM,
  SchoolUserRoleIdEnum.SPOC,
]);

export const ExternalSchoolUserRoleIds: ReadonlyArray<number> = Object.freeze([
  SchoolUserRoleIdEnum.SPOC,
  SchoolUserRoleIdEnum.KDM,
  SchoolUserRoleIdEnum.PRINCIPAL,
]);
